import SupportFooter from './SupportFooter';

export default SupportFooter;
